/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Injectable } from '@angular/core';
import { InteractionLogService } from '@wfm/core';
import { LogEntry } from '@core/lib/services/log-entry';
import { UtilService } from '@app/util/util.service';
import { AppConfigService } from '@app/common/app-config.service';
import { WindowRef } from '@app/common/window-ref.service';
import { Router } from '@angular/router';
import { Logger } from '@core/lib/services';

const log = new Logger('LoginService');

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private _username: string;
  private _ssoLoginError: string = undefined;

  constructor(
    private router: Router,
    private interactionLogService: InteractionLogService,
    private utilService: UtilService,
    private windowRef: WindowRef,
    private appConfigService: AppConfigService
  ) {}

  set username(username: string) {
    this._username = username;
    LogEntry.setUsername(username);
    this.interactionLogService.username = username;
  }

  get username() {
    return this._username;
  }

  set ssoLoginError(error: string) {
    this._ssoLoginError = error;
  }

  get ssoLoginError() {
    return this._ssoLoginError;
  }

  navigateToLoginSuccessPage() {
    this.appConfigService.setUserId(this._username);
    const window = this.windowRef.nativeWindow;
    window.play = window.play || {};
    window.play.loggedInUserId = this._username;
    window.play.buildUrl = this.utilService.getAppBaseUrl();
    this.router.navigate(['ui'], { replaceUrl: false }).catch(ex => {
      log.error('navigate to login success page failed ', ex);
    });
  }
}
